import React from 'react';
import SocialLinks from './SocialLinks/SocialLinks';
import RaceXTokenAddress from './RaceXTokenAddress/RaceXTokenContract';
import Gallery from './Gallery/Gallery';
import MintCalendar from '../../components/MintCalendar/MintCalendar';
import RoadMap from '../../components/RoadMap/RoadMap';
import TokenInfo from './TokenInfo/TokenInfo';
import RaceXTool from './RaceXTool/RaceXTool';
import OurTeam from '../../components/OurTeam/OurTeam';
import MoreInfo from './MoreInfo/MoreInfo';
import FAQ from '../../components/FAQ/FAQ';
import MintYourRaceCar from './MintYourRaceCar/MintYourRaceCar';
import LinkButton from '../../components/LinkButton/LinkButton';
import YellowCar from '../../assets/images/yellow_car.png';
import RedCar from '../../assets/images/red_car.png';
import SteeringWheel from '../../assets/images/steering_wheel.png';
import Power from '../../assets/images/power.png';
import CarVideo1 from '../../assets/video/car_1.mp4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import './Home.css';
import ScrollToTop from 'react-scroll-up'

const Home = () => {
  return (
    <div className='home'>
      <SocialLinks />

      <div className='home__carVideo'>
        <video src={CarVideo1} type='video/mp4' width='100%' autoPlay muted/>
        <div className='home__carVideo__desc'>
          <div>
            <div className='home__subtitle' style={{marginTop:0}}>Welcome to DCRC - RaceX</div>
            <div className='home__subtext'>
              The first Race-2-Earn gaming platform on the Avalanche!
            </div>
            <a href='#mint' className='home__btn__mint' style={{width:'140px'}}>
              <span style={{marginRight: '10px'}}>Mint now</span>
              <FontAwesomeIcon icon={faCaretDown}/>
            </a>
          </div>
        </div>
      </div>

      <RaceXTokenAddress />
      <MintYourRaceCar />

      <div className='home__paragrph' style={{flexDirection:'column'}} id='theGame'>
        <label className='home__subtitle'>ABOUT THE GAME</label>
        <label className='home__subtext2'>
        🏁<strong>DCRC – RaceX</strong>🏁 is the first Race-2-Earn gaming platform on the Avalanche ecosystem ! 🎮 <br/>
        It will also be the first racing <strong>simulation🕹️</strong> to combine both real-world🌍 on-the-road racing with virtual racing. A first of its kind <strong>simulation engine</strong> currently in development👨‍💻.
        </label>
      </div>

      <div className='home__desc home__desc__first home__paragrph'>
        <img src={YellowCar} className='home__desc__img' alt='yellow car' />
        <div style={{display:'flex', flexDirection:'column', width:'320px'}}>
          <img src={SteeringWheel} className='home__desc__logo' alt='steering' />
          <label className='home__desc__title'>How does it work?</label>
          <label className='home__desc__text'>
            The game will allow 🏎<strong>RaceCar</strong> NFT holders to play with a <strong>representation</strong> of the same car inside the simulation, allowing users to benefit from <strong>Race-2-Earn</strong> 💰 features on the platform.
          </label>
        </div>
      </div>

      <div className='home__desc home__paragrph'>
        <div style={{display:'flex', flexDirection:'column', width:'320px'}}>
          <img src={Power} className='home__desc__logo' alt='steering' />
          <label className='home__desc__title'>Upgrade your RaceX NFT</label>
          <label className='home__desc__text'>
          The 🏎️RaceCars will be upgradeable👨‍🔧 in-game using a burn and re-mint system : adding body kits, changing colors or car-wrapping, adding decals, changing the wheels and tires will also modify your 🏎️RaceCar NFT out-game🎟️. Users will be able to reconstruct their NFTs and make it completely unique according to their vision or strategy! The 🏎️RaceCars will also be upgradeable in terms of performance⚡, as owners will be able to purchase performance upgrades to improve the abilities of their RaceCars in the virtual races.   </label>
        </div>
        <img src={RedCar} className='home__desc__img' alt='red car' />
      </div>

      <Gallery />

      <div className='home__paragrph' style={{flexDirection:'column'}}>
        <label className='home__subtitle'>WHICH CAR WILL YOU GET ?</label>
        <label className='home__desc__text'>There is only one way for you to know..</label>
      </div>
     
      {/* <label className='home__mint__bottom'>
        1745 <span style={{color:'#FFB300'}}>NFKeys</span> have been minted during the Pre-Sale !
      </label> */}

      <MintCalendar />
      <RoadMap />
      <TokenInfo />
      <RaceXTool />
      <OurTeam />
      <MoreInfo />
      <FAQ />

    </div>
  )
}

export default Home;